import {
  FETCH_DRIVERS_EARNING,
  FETCH_DRIVERS__EARNING_SUCCESS,
  FETCH_DRIVERS__EARNING_FAILED,
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { get } from "firebase/database";

// Portal-only earnings rollup (settings.useReportRollups) — reads the
// CF-maintained /report_rollups/driver_monthly node instead of scanning
// bookings. Mirrors the useCustomerOnDemand gate in usersactions.js: an
// absent/false flag, or any role outside the staff set (fleetadmin keeps its
// legacy fleet-scoped query; every mobile role too), keeps the legacy path
// below byte-identical. The legacy admin path is silently limited to the
// default 30-day bookingListRef window; the rollup lists every month.
const ROLLUP_ROLES = ['admin', 'finance', 'callcenteragent', 'callcentersupervisor'];
const useReportRollups = () => {
  try { return store.getState().settingsdata.settings.useReportRollups === true; } catch (_) { return false; }
};
const rollupEligible = (usertype) => ROLLUP_ROLES.indexOf(usertype) >= 0;
const MONTH_KEY_RE = /^\d{4}-\d{2}$/;
const ADDIS_OFFSET_MS = 3 * 60 * 60 * 1000;
const MONTHS_NAME = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const num = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };
// Rollup month keys are Addis-time 'YYYY-MM'; `dated` is the first instant of
// that month (legacy used the first counted booking's tripdate — no view
// renders it, but the field is kept so the payload shape is unchanged).
const parseMonthKey = (mk) => {
  const year = parseInt(mk.slice(0, 4), 10);
  const month = parseInt(mk.slice(5, 7), 10) - 1;
  return { year: year, month: month, dated: Date.UTC(year, month, 1) - ADDIS_OFFSET_MS };
};
// Map one driver_monthly/{month}/{uid} record to the exact legacy row, plus
// driverId (DriverEarning's ClickableUserLink reads rowData.driverId, which
// the legacy branch never set).
const mapDriverMonth = (mk, uid, d, settings) => {
  const { year, month, dated } = parseMonthKey(mk);
  return {
    dated: dated,
    year: year,
    month: month,
    monthsName: MONTHS_NAME[month],
    driverName: d.driverName,
    driverShare: num(d.driverShare).toFixed(settings.decimal),
    driverVehicleNo: d.vehicle_number,
    driverUId: uid,
    driverId: uid,
    uniqueKey: year + '_' + month + '_' + uid,
    total_rides: num(d.total_rides)
  };
};

export const fetchDriverEarnings = () => async (dispatch) => {

  const {
    bookingListRef,
    settingsRef,
    reportRollupDriverRef
  } = firebase;

  dispatch({
    type: FETCH_DRIVERS_EARNING,
    payload: null
  });

  const userInfo = store.getState().auth.profile;
  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  if (useReportRollups() && rollupEligible(userInfo && userInfo.usertype)) {
    try {
      const rollupSnap = await get(reportRollupDriverRef);
      const months = rollupSnap.val();
      const arr = [];
      if (months) {
        Object.keys(months).filter(mk => MONTH_KEY_RE.test(mk) && months[mk]).forEach(mk => {
          Object.keys(months[mk]).forEach(uid => {
            const d = months[mk][uid];
            if (d && num(d.total_rides) > 0) arr.push(mapDriverMonth(mk, uid, d, settings));
          });
        });
      }
      if (arr.length) {
        dispatch({
          type: FETCH_DRIVERS__EARNING_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_DRIVERS__EARNING_FAILED,
          payload: "No data available."
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_DRIVERS__EARNING_FAILED,
        payload: error.message
      });
    }
    return;
  }

  try {
    const snapshot = await get(bookingListRef(userInfo.uid, userInfo.usertype));
    if (snapshot.val()) {
      const mainArr = snapshot.val();
      var monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var renderobj = {};
      Object.keys(mainArr).map(j => {

        if ((mainArr[j].status === 'PAID' || mainArr[j].status === 'COMPLETE') && mainArr[j].driver_share !== undefined) {
          let bdt = new Date(mainArr[j].tripdate);
          let uniqueKey = bdt.getFullYear() + '_' + bdt.getMonth() + '_' + mainArr[j].driver;
          if (renderobj[uniqueKey] && renderobj[uniqueKey].driverShare > 0) {
            renderobj[uniqueKey].driverShare = (parseFloat(renderobj[uniqueKey].driverShare) + parseFloat(mainArr[j].driver_share)).toFixed(settings.decimal);
            renderobj[uniqueKey]['total_rides'] = renderobj[uniqueKey]['total_rides'] + 1;
          } else {
            renderobj[uniqueKey] = {};
            renderobj[uniqueKey]['dated'] = mainArr[j].tripdate;
            renderobj[uniqueKey]['year'] = bdt.getFullYear();
            renderobj[uniqueKey]['month'] = bdt.getMonth();
            renderobj[uniqueKey]['monthsName'] = monthsName[bdt.getMonth()];
            renderobj[uniqueKey]['driverName'] = mainArr[j].driver_name;
            renderobj[uniqueKey]['driverShare'] = parseFloat(mainArr[j].driver_share).toFixed(settings.decimal);
            renderobj[uniqueKey]['driverVehicleNo'] = mainArr[j].vehicle_number;
            renderobj[uniqueKey]['driverUId'] = mainArr[j].driver;
            renderobj[uniqueKey]['uniqueKey'] = uniqueKey;
            renderobj[uniqueKey]['total_rides'] = 1;
          }
        }
        return null;
      });
      if (renderobj) {
        const arr = Object.keys(renderobj).map(i => {
          renderobj[i].driverShare = parseFloat(renderobj[i].driverShare).toFixed(settings.decimal)
          return renderobj[i]
        })
        dispatch({
          type: FETCH_DRIVERS__EARNING_SUCCESS,
          payload: arr
        });
      }

    } else {
      dispatch({
        type: FETCH_DRIVERS__EARNING_FAILED,
        payload: "No data available."
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_DRIVERS__EARNING_FAILED,
      payload: error.message
    });
  }
};
